"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarsSimilar = void 0;
var react_1 = __importDefault(require("react"));
var CardAuto_1 = require("../cardAuto/CardAuto");
var Loader_1 = require("../loader/Loader");
var react_2 = require("swiper/react");
var useCarsSimilar_1 = require("../../hook/useCarsSimilar");
exports.CarsSimilar = react_1.default.memo(function (_a) {
    var car = _a.car;
    var _b = (0, useCarsSimilar_1.useCarsSimilar)(car), isLoading = _b.isLoading, isError = _b.isError, carsSimilar = _b.carsSimilar, slidesPerView = _b.slidesPerView;
    if (isLoading) {
        return react_1.default.createElement(Loader_1.Loader, null);
    }
    if (isError) {
        return react_1.default.createElement(react_1.default.Fragment, null, "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043F\u043E\u0445\u043E\u0436\u0438\u0445 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439");
    }
    var uniqueCarsSimilar = Array.from(new Set(carsSimilar.map(function (c) { return c.id; })))
        .map(function (id) { return carsSimilar.find(function (c) { return c.id === id; }); })
        .filter(function (c) { return c !== undefined; });
    return (react_1.default.createElement(react_2.Swiper, { className: "swiper-latest-arrivals", slidesPerView: slidesPerView, spaceBetween: 24 }, uniqueCarsSimilar.map(function (carSimilar) { return (react_1.default.createElement(react_2.SwiperSlide, { key: carSimilar.id },
        react_1.default.createElement(CardAuto_1.CardAuto, __assign({}, carSimilar)))); })));
});
